// src/AudioSpectrum/effects/horizontalBars.js
import { getColor } from '../colorUtils.js';

export const drawHorizontalBars = (ctx, frequencyData, width, height) => {
  const barCount = Math.min(frequencyData.length / 2, 64);
  const barHeight = height / barCount;
  
  ctx.clearRect(0, 0, width, height);
  
  for (let i = 0; i < barCount; i++) {
    const value = frequencyData[i];
    const barWidth = (value / 255) * width;
    
    ctx.fillStyle = getColor(value);
    ctx.fillRect(0, i * barHeight, barWidth, barHeight - 2);
  }
};